export enum LabelColors {
  Chilli = '0',
  Curry = '1',
  SingleSpices = '2',
  Herbs = '3',
  Mix = '4',
  Paprika = '5',
  Pepper = '6',
  Salt = '7',
}
